import React, { useState } from 'react'
import Papa from 'papaparse'
import api from '../../api'
import { Heading } from '@workwhile/ui'

function TipFileProcess() {
  const [file, setFile] = useState(null)
  const [companyId, setCompanyId] = useState('')
  const [processing, setProcessing] = useState(false)
  const [errors, setErrors] = useState([])
  const [paymentItems, setPaymentItems] = useState([])

  const handleFileChange = (e) => {
    let file = e.target.files[0]

    // Validate file type
    if (file.type !== 'text/csv') {
      alert('Invalid file type. Only CSV files are allowed.')
      setFile(null)
      return
    }

    setFile(file)
  }

  const handleCompanyIdChange = (e) => {
    setCompanyId(e.target.value)
  }

  const handleFileParseAndProcess = async () => {
    // Validate the file is selected
    if (!file || !companyId) {
      return
    }
    setProcessing(true)
    let localErrors = []
    let localPaymentIds = []

    // Parse and validate the CSV
    const parseResult = await new Promise((resolve) => {
      Papa.parse(file, {
        header: true,
        complete: (results) => {
          resolve(results)
        },
      })
    })

    const rows = parseResult.data

    // Validate column names
    const columns = Object.keys(rows[0])
    if (!columns.includes('phone_number') || !columns.includes('amount')) {
      localErrors.push(
        "Invalid column structure. The CSV must have the columns: 'phone_number' and 'amount', please check the names and make sure there is no extra space or typo."
      )
      setErrors(localErrors)
      setProcessing(false)
      return
    }

    // CSV parsed, and validated.
    for (const row of rows) {
      const phoneNumber = row.phone_number
      const amount = row.amount
      const rawShiftId =
        typeof row.shift_id === 'string' ? row.shift_id.trim() : row.shift_id

      let shiftId
      if (rawShiftId !== undefined && rawShiftId !== '') {
        shiftId = Number(rawShiftId)
        if (!Number.isInteger(shiftId)) {
          localErrors.push(
            `Invalid shift_id "${rawShiftId}" for phone number ${phoneNumber}: must be a whole number.`
          )
          continue
        }
      }

      try {
        const res = await api.post(
          `/admin/company/${companyId}/tips`,
          {
            phone_number: phoneNumber,
            amount,
            ...(shiftId !== undefined ? { shift_id: shiftId } : {}),
          },
          {
            validateStatus: false,
          }
        )
        if (res.status === 201) {
          localPaymentIds.push(res.data)
        } else {
          localErrors.push(
            `Failed to post tip for phone number ${phoneNumber}: ${res.data.message.general}`
          )
        }
      } catch (error) {
        console.error('API request error:', error)
      }
    }

    setPaymentItems(localPaymentIds.length > 0 ? localPaymentIds : [])
    setErrors(localErrors.length > 0 ? localErrors : [])
  }

  return (
    <div>
      <Heading level={3}>1. Enter Company ID</Heading>
      <input
        type="text"
        placeholder="Company ID"
        value={companyId}
        onChange={handleCompanyIdChange}
      />
      <br />
      <br />
      <br />
      <Heading level={3}>2. Upload Tip CSV</Heading>
      <input type="file" onChange={handleFileChange} />
      <br />
      <br />
      <br />
      <Heading level={3}>3. Process</Heading>
      <button onClick={handleFileParseAndProcess} disabled={processing}>
        {processing ? 'Processing...' : 'Process'}
      </button>
      <br />
      <br />
      {errors.length > 0 && (
        <div>
          <Heading level={3}>There were the following errors:</Heading>
          {errors.map((error, index) => (
            <h5 key={index}>{error}</h5>
          ))}
        </div>
      )}
      <br />
      <br />
      {paymentItems.length > 0 && (
        <div>
          <Heading level={3}>The following UserPayments were created:</Heading>
          {paymentItems.map((id) => (
            <h5 key={id}>{id}</h5>
          ))}
        </div>
      )}
    </div>
  )
}

export default TipFileProcess
